var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-intelligent-vehicle-management"},[_c('top-nav',{attrs:{"banner":_vm.data.banner,"color":"#333333","isParent":""}}),_vm._v(" "),_c('tech-empowerment'),_vm._v(" "),_c('product-list'),_vm._v(" "),_c('customer-wall'),_vm._v(" "),_c('footer-resolution'),_vm._v(" "),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }